import { Fragment, useEffect, useState } from "react"
import PreviewImage from "./PreviewImage"
import { DepositPics } from "src/types"
import process from "process"
type GalPicParams = {
  photoUrl: DepositPics[]
  code: string
  title: string
  description: string
  route?: string
}
const GalleryPics:React.FC<GalPicParams> = ({photoUrl,code, title, description, route}) => {
  const [previewDetail, setPreviewDetail] = useState(false)
  const [photoPrewiew, setPhotoPreview] = useState<string>('')
  const [routepic,setroutepic] = useState('')
  const handleView = (photo:string) => {
    setPhotoPreview(photo)
    setPreviewDetail(true)
  }

  useEffect(() => {
    if(!route){
      setroutepic((process?.env?.REACT_APP_DEPOSIT_IMAGE || '')+code)
    }else{
      switch(route){
        case 'coins':
          setroutepic(process?.env?.REACT_APP_COINSPICTURE || '')
        break
      }
    }
  }, [route])
  
    return (
      <>
          <div
           className="flex flex-wrap items-center justify-center gap-2 overflow-auto"
            style={{maxHeight: '50vh'}}
          >
            {photoUrl.map((p,key) => (
              <Fragment key={key.toString()}>

                <div  key={key.toString()}  className="border border-stone-400 rounded-md">
                  <div
                    onClick={() => handleView(`${routepic}/${p.photoUrl}`)}
                    className="w-20 h-32 bg-cover bg-center rounded-t-md cursor-pointer" 
                    style={{backgroundImage: `url(${routepic}/${p.photoUrl})`}}
                    >
                  </div>
                </div>

                {/*p.typeFile.includes('video') && 
                  <div style={{ width: "18rem", maxHeight: "auto" }}  className="relative" >
                    <video width="100%"  controls className="">
                      <source src={`${routepic}/${p.photoUrl}`} id={p.photoUrl} />
                        Your browser does not support HTML5 video.
                    </video>
                  </div>
            */}
              </Fragment>
            ))}
          </div>
          <PreviewImage
              arrayGallery={photoUrl
                ?.filter(p => p.typeFile.includes("image"))
                ?.map(p => ({...p, photoUrl: `${routepic}/${p.photoUrl}`}))}
              img={photoPrewiew}
              isOpen={previewDetail}
              closeModal={() => setPreviewDetail(false)} 
              title={title}
              description={description} 
          />
      </>
    )
}

export default GalleryPics